<!-- Item wrapper  -->
<ng-container *hasPermission="item.permissions">
    <div
        class="hippo-vertical-navigation-item-wrapper cursor-pointer hover:bg-black/30 hover:rounded group"
        [class.hippo-vertical-navigation-item-has-subtitle]="!!item.subtitle"
        [ngClass]="item.classes?.wrapper"
        (click)="toggleShow()">
        <div class="hippo-vertical-navigation-item">
            <!-- Icon -->
            <ng-container *ngIf="item.icon">
                <mat-icon
                    class="hippo-vertical-navigation-item-icon"
                    [ngClass]="item.classes?.icon"
                    [svgIcon]="item.icon"></mat-icon>
            </ng-container>

            <!-- Title & Subtitle -->
            <div class="hippo-vertical-navigation-item-title-wrapper">
                <div
                    class="hippo-vertical-navigation-item-title group-hover:text-white">
                    <span [ngClass]="item.classes?.title">
                        {{ item.title }}
                    </span>
                </div>
                <ng-container *ngIf="item.subtitle">
                    <div class="hippo-vertical-navigation-item-subtitle">
                        <span [ngClass]="item.classes?.subtitle">
                            {{ item.subtitle }}
                        </span>
                    </div>
                </ng-container>
            </div>

            <!-- Badge -->
            <ng-container *ngIf="item.badge">
                <div class="hippo-vertical-navigation-item-badge">
                    <div
                        class="hippo-vertical-navigation-item-badge-content"
                        [ngClass]="item.badge.classes">
                        {{ item.badge.title }}
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <ng-container *ngIf="item.show">
        <ng-container *ngFor="let item of item.children; trackBy: trackByFn">
            <!-- Skip the hidden items -->
            <ng-container
                *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">
                <!-- Basic -->
                <ng-container *ngIf="item.type === 'basic'">
                    <ng-container *hasPermission="item.permissions">
                        <hippo-vertical-navigation-basic-item
                            [item]="item"
                            [name]="
                                name
                            "></hippo-vertical-navigation-basic-item>
                    </ng-container>
                </ng-container>

                <!-- Collapsable -->
                <ng-container *ngIf="item.type === 'collapsable'">
                    <hippo-vertical-navigation-collapsable-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="
                            autoCollapse
                        "></hippo-vertical-navigation-collapsable-item>
                </ng-container>

                <!-- Divider -->
                <ng-container *ngIf="item.type === 'divider'">
                    <hippo-vertical-navigation-divider-item
                        [item]="item"
                        [name]="name"></hippo-vertical-navigation-divider-item>
                </ng-container>

                <!-- Group -->
                <ng-container *ngIf="item.type === 'group'">
                    <hippo-vertical-navigation-group-item
                        [item]="item"
                        [name]="name"></hippo-vertical-navigation-group-item>
                </ng-container>

                <!-- Spacer -->
                <ng-container *ngIf="item.type === 'spacer'">
                    <hippo-vertical-navigation-spacer-item
                        [item]="item"
                        [name]="name"></hippo-vertical-navigation-spacer-item>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-container>
